import { render, staticRenderFns } from "./TranslatedArticles.pug?vue&type=template&id=027d8bbd&lang=pug&external"
import script from "./TranslatedArticles.js?vue&type=script&lang=js&external"
export * from "./TranslatedArticles.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports